import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'emailHyperlink'
})
export class EmailHyperlinkPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    if (value) {
      return this.sanitizer.bypassSecurityTrustHtml('<a href="mailto:' + value + '">' + value + '</a>');
    } else {
      return ''
    }
  }
}
